import { render } from "./WalletProfile.vue?vue&type=template&id=2480e2c5"
import script from "./WalletProfile.vue?vue&type=script&lang=js"
export * from "./WalletProfile.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__